import { Device } from '@/types';
import { RouterHelper } from '../router';
import store from '../store/store';

export class DeviceMutator {
  public static toTabular(device: Device, config: any): any {
    const tableConfig: any = {
      device_id: {
        value: device.device_id,
        property: 'device.device_id',
        navigateTo: device.id,
      },
      network_id: {
        value: device.chip!.identifier,
        property: 'chip.identifier',
      },
      type: {
        value: device.device_version ? device.device_version.name : null,
        property: 'device_version.name',
      },
      status: {
        value: device.status.name,
        property: 'status.name',
        classes: 'capitalize',
      },
      stage: {
        value: device.stage.name,
        property: 'stage.name',
        classes: 'capitalize',
      },
      project: {
        value: device.project ? device.project.name : null,
        property: 'project.name',
        raiseEvent: device.project ? 'SwitchProject' : null,
      },
      site: {
        value: device.site ? device.site.name : null,
        property: 'site.name',
      },
      location: {
        value: device.location ? device.location.name : null,
        property: 'location.name',
      },
      id: device.id,
      last_seen: {
        value: device.last_seen,
        property: 'last_seen',
      },
    };

    if (config && config.exclude) {
      (config.exclude as string[]).forEach((value) => delete tableConfig[value]);
    }

    return tableConfig;
  }
}
